// Footer.jsx
import './Footer.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Footer() {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    const [showBackToTop, setShowBackToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowBackToTop(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleNavigation = (path) => {
        navigate(path);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            {/* Main Footer Section */}
            <div className="footer-main">
                <div className="container">
                    <div className="footer-grid">
                        {/* Company Info */}
                        <div className="footer-section">
                            <h5 className="footer-title">Koru AI</h5>
                            <p className="footer-description">
                                Discover and compare the best AI tools to supercharge your workflow.
                                We curate the latest and most effective AI solutions for creators,
                                developers, and businesses.
                            </p>
                            <div className="footer-badge">
                                <span>{currentYear} AI Tools Database</span>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="footer-section">
                            <h5 className="footer-title">Quick Links</h5>
                            <ul className="footer-links">
                                <li><button onClick={() => handleNavigation('/')}>Home</button></li>
                                <li><button onClick={() => handleNavigation('/category')}>All Tools</button></li>
                                <li><button onClick={() => handleNavigation('/privacy')}>Privacy Policy</button></li>
                                <li><button onClick={() => handleNavigation('/contact')}>Contact</button></li>
                            </ul>
                        </div>

                        {/* Contact Info */}
                        <div className="footer-section">
                            <h5 className="footer-title">Get in Touch</h5>
                            <ul className="footer-contact">
                                <li>
                                    <span className="contact-icon">📧</span>
                                    <span>c84289798@gmail.com</span>
                                </li>
                                <li>
                                    <span className="contact-icon">🕐</span>
                                    <span>24/7 Support Available</span>
                                </li>
                                <li>
                                    <span className="contact-icon">📍</span>
                                    <span>Global AI Tools Directory</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <p className="copyright">
                            &copy; {currentYear} Koru AI. All rights reserved.
                        </p>
                        <div className="footer-legal-links">
                            <a onClick={() => handleNavigation('/privacy')} className="text-white privacy">
                                Privacy Policy
                            </a>
                            <a onClick={() => handleNavigation('/terms')} className="text-white privacy">
                                Terms and Conditions
                            </a>
                            <a onClick={() => handleNavigation('/cookies')} className="text-white privacy">
                                Cookies Policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top Button */}
            {showBackToTop && (
                <button className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <i className="bi bi-arrow-up"></i>
                </button>
            )}
        </footer>
    );
}

export default Footer;